import React from 'react'
import { Box, Input, InputGroup, InputLeftElement, InputRightElement } from '@chakra-ui/react'
import { SearchIcon } from '@chakra-ui/icons';
import { ISearchBarProps } from './searchBar.types';

const CloseButtonSvg = (props: any) => {
  return (
    <Box {...props}>
      <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.6279 2.0625C9.90645 2.0625 8.22368 2.58668 6.79237 3.56874C5.36106 4.55081 4.24549 5.94665 3.58673 7.57977C2.92797 9.21288 2.7556 11.0099 3.09144 12.7436C3.42727 14.4773 4.25621 16.0698 5.47344 17.3198C6.69068 18.5697 8.24152 19.4209 9.92987 19.7658C11.6182 20.1106 13.3682 19.9336 14.9586 19.2572C16.549 18.5807 17.9083 17.4352 18.8647 15.9654C19.8211 14.4956 20.3315 12.7677 20.3315 11C20.3289 8.63047 19.411 6.35877 17.7794 4.68326C16.1477 3.00774 13.9354 2.06524 11.6279 2.0625ZM14.7793 13.2639C14.8416 13.3277 14.891 13.4035 14.9247 13.4869C14.9584 13.5704 14.9758 13.6598 14.9759 13.7502C14.9759 13.8405 14.9586 13.9299 14.925 14.0134C14.8913 14.0969 14.842 14.1727 14.7798 14.2366C14.7176 14.3005 14.6437 14.3511 14.5624 14.3857C14.4812 14.4202 14.394 14.438 14.3061 14.4379C14.2181 14.4379 14.131 14.42 14.0497 14.3854C13.9685 14.3508 13.8947 14.3 13.8326 14.2361L11.6279 11.9722L9.42318 14.2361C9.29759 14.3648 9.12739 14.437 8.94997 14.4369C8.77254 14.4368 8.60241 14.3644 8.47695 14.2356C8.3515 14.1067 8.28097 13.932 8.28088 13.7498C8.28079 13.5677 8.35113 13.3929 8.47645 13.2639L10.6811 11L8.47645 8.73608C8.35113 8.60712 8.28079 8.43234 8.28088 8.25015C8.28097 8.06796 8.3515 7.89326 8.47695 7.76443C8.60241 7.63561 8.77254 7.56319 8.94997 7.56309C9.12739 7.56299 9.29759 7.63523 9.42318 7.76392L11.6279 10.0278L13.8326 7.76392C13.9581 7.63523 14.1284 7.56299 14.3058 7.56309C14.4832 7.56319 14.6533 7.63561 14.7788 7.76443C14.9042 7.89326 14.9748 8.06796 14.9749 8.25015C14.975 8.43234 14.9046 8.60712 14.7793 8.73608L12.5746 11L14.7793 13.2639Z" fill="#878787" />
      </svg>
    </Box>
  )
}

export function SearchBar({ query, onSubmit, onChange }: ISearchBarProps) {

  const clearSearch = () => {
    onChange("");
    onSubmit(true);
  };

  const handleChange = ({ target: { value } }: any) => {
    onChange(value);
  }

  const handleSubmit = (e: any) => {
    e.preventDefault();
    onSubmit();
  }

  return (
    <Box width="100%" maxWidth="800px"
      marginInline="auto"
    >
      <form onSubmit={handleSubmit}>
        <InputGroup >
          <InputLeftElement
            pointerEvents="none"
            children={<SearchIcon fontSize={15.5} color="#C0C0C0" />}
          />
          {query && <InputRightElement children={<CloseButtonSvg cursor="pointer" onClick={clearSearch} fontSize={13.5} color="#C0C0C0" />} />}

          <Input
            backgroundColor="#F2F3F5"
            value={query}
            onChange={handleChange}
            borderRadius={21} 
            type="text" 
            placeholder=""
            border="none"
            _focus={{
              outline: "none",
              border: "none",
              boxShadow: "none"
            }}
          />
        </InputGroup>
      </form>
    </Box>
  )
}